import { useState, useRef, useEffect } from "react";

const Timeline = (props) => {
  const { currentIndex, setCurrentIndex, slides, totalSlides, infoOpen } = props;

  const [width, setWidth] = useState(0);
  const animationRef = useRef(null);
  const startTimeRef = useRef(null);
  const elapsedRef = useRef(0);

  const duration = 5000; 

  useEffect(() => {
    if (!infoOpen) {
      startTimeRef.current = performance.now() - elapsedRef.current;
      animate();
    } else {
      cancelAnimationFrame(animationRef.current);
    }
    return () => cancelAnimationFrame(animationRef.current);
  }, [infoOpen]);

  const resetAnimation = () => {
    cancelAnimationFrame(animationRef.current);
    setWidth(0);
    elapsedRef.current = 0;
    startTimeRef.current = performance.now();
    requestAnimationFrame(animate);
  }

  useEffect(()=>{
    resetAnimation();
  },[currentIndex])

  const animate = () => {

    cancelAnimationFrame(animationRef.current);
    
    const step = (timestamp) => {
        if (infoOpen) return;

      elapsedRef.current = timestamp - startTimeRef.current;
      let progress = Math.min(elapsedRef.current / duration, 1);
      setWidth(progress * 100);

      if (progress >= 1) {
        setCurrentIndex((currentIndex + 1) % (totalSlides));
      } else {
        setWidth(progress * 100);
        animationRef.current = requestAnimationFrame(step);
      }
    };

    animationRef.current = requestAnimationFrame(step);
  };

  return (
    <div className="timeline__outer">
      <div
        className={`timeline__inner ${slides[currentIndex].timeline?slides[currentIndex].timeline:''}`}
        style={{
          width: `${width}%`,
        }}
      />
    </div>
  );
};

export default Timeline;
